module.exports = __webpack_public_path__ + "img/Whiplash _Fletcher.4b7ad11e.jpeg";